import React from 'react'
import { Navbar, Nav, Container } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { useAuth } from '../../components/auth/useAuth'
import { Link } from 'react-router-dom'

export default function Menu() {
	const { t } = useTranslation()
	const { clientauth, logout } = useAuth()
	const role = String(clientauth?.rol || '').toLowerCase()

	return (
		<div className='cabecera d-flex align-items-center px-4'>
			<Navbar id="menu" expand="lg" className="w-100">
				<Container fluid>
					<Navbar.Brand>
						<img
							src="/images/logo-inicio.png"
							alt="Logotipo"
							height={36}
						/>
					</Navbar.Brand>
					<Navbar.Toggle aria-controls="basic-navbar-nav" />
					<Navbar.Collapse id="basic-navbar-nav">
						<Nav className="ms-auto align-items-lg-center gap-1">
							{role === 'admin' && (
								<>
									<Nav.Link as={Link} to="/admin/dashboard"><i className="fas fa-chart-pie me-1"></i>{t('menu.index')}</Nav.Link>
									<Nav.Link as={Link} to="/admin/users"><i className="fas fa-users me-1"></i>{t('menu.users')}</Nav.Link>
									<Nav.Link as={Link} to="/admin/products"><i className="fas fa-barcode me-1"></i>{t('menu.products')}</Nav.Link>
									<Nav.Link as={Link} to="/admin/departments"><i className="fas fa-building me-1"></i>{t('menu.departments')}</Nav.Link>
									<Nav.Link as={Link} to="/admin/delegations"><i className="fas fa-warehouse me-1"></i>{t('menu.delegations')}</Nav.Link>
									<Nav.Link as={Link} to="/admin/product-states"><i className="fas fa-tags me-1"></i>{t('menu.productStates')}</Nav.Link>
									<Nav.Link as={Link} to="/admin/product-templates"><i className="fas fa-layer-group me-1"></i>{t('menu.productTemplates')}</Nav.Link>
									<Nav.Link as={Link} to="/admin/chatbot"><i className="fas fa-comment-dots me-1"></i>{t('menu.chatbot')}</Nav.Link>
									{/*
									<Nav.Link as={Link} to="/admin/chatbot-logs"><i className="fas fa-history me-1"></i>{t('menu.chatbotLogs')}</Nav.Link>
									*/}
								</>
							)}
							{(role === 'department') && (
								<>
									<Nav.Link as={Link} to={`/${role}/dashboard`}><i className="fas fa-chart-pie me-1"></i>{t('menu.index')}</Nav.Link>
									<Nav.Link as={Link} to={`/${role}/products`}><i className="fas fa-barcode me-1"></i>{t('menu.products')}</Nav.Link>
									<Nav.Link as={Link} to={`/${role}/chatbot`}><i className="fas fa-comment-dots me-1"></i>{t('menu.chatbot')}</Nav.Link>
								</>
							)}
							{(role === 'commercial') && (
								<>
									<Nav.Link as={Link} to={`/${role}/chatbot`}><i className="fas fa-comment-dots me-1"></i>{t('menu.chatbot')}</Nav.Link>
								</>
							)}
							<div className="ms-3 d-flex align-items-center gap-3">
								<div className="user-info d-none d-lg-flex">
									<div className="text-end">
										<div className="user-info-name">{clientauth?.name || clientauth?.username}</div>
										<div className="user-info-role">{t('admin.users.' + role) || role}</div>
									</div>
									<div className="avatar-initials">
										{(clientauth?.name || clientauth?.username || 'U').charAt(0).toUpperCase()}
									</div>
								</div>
								<Nav.Link as={Link} to="/" onClick={logout} className="d-flex align-items-center gap-1">
									<i className="fas fa-sign-out-alt"></i>
								</Nav.Link>
							</div>
						</Nav>
					</Navbar.Collapse>
				</Container>
			</Navbar>
		</div>
	)
}
